// extracted by mini-css-extract-plugin
export default {"notification_element":"styles_notification_element__LHD0K"};